export default __webpack_public_path__ + "3438efd6de3db377f17ee02c60caa04e.png";